import { render, staticRenderFns } from "./ModalChangeDeliveryFromViewSale.vue?vue&type=template&id=2b48481e&scoped=true"
import script from "./ModalChangeDeliveryFromViewSale.vue?vue&type=script&lang=js"
export * from "./ModalChangeDeliveryFromViewSale.vue?vue&type=script&lang=js"
import style0 from "./ModalChangeDeliveryFromViewSale.vue?vue&type=style&index=0&id=2b48481e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b48481e",
  null
  
)

export default component.exports